import * as MediaLibrary from "~/ui/expo-media-library"
import * as FileSystem from "~/ui/expo-file-system"

export const getAssetInfoFromAssetUri = async (path: string) => {
  try {
    const info = await FileSystem.getInfoAsync(path)
    if (info.exists) {
      return {
        uri: info.uri ?? path,
        size: info.size ?? 0,
        exists: true,
        isDirectory: !!info.isDirectory,
      }
    }
  } catch {
    /* fall through */
  }

  return {
    uri: path,
    size: 0,
    exists: false,
    isDirectory: false,
  }
}

export const getAssetUriFromAssetID = async (id: string) => {
  try {
    const assetInfo = await MediaLibrary.getAssetInfoAsync(id)
    return assetInfo.localUri || assetInfo.uri
  } catch {
    return ""
  }
}

export const getAssetSizeFromAssetUri = async (uri: string) => {
  try {
    const fileInfo = await FileSystem.getInfoAsync(uri)
    if (fileInfo.exists) {
      return fileInfo.size ?? 0
    }
    return 0
  } catch {
    return 0
  }
}

export const getAssetDetail = async (item: {
  id: string
  filename: string
  mediaType?: string
}) => {
  const ext = item.filename.split(".")[1]?.toLowerCase() ?? "jpg"
  const uri = await getAssetUriFromAssetID(item.id)
  const size = await getAssetSizeFromAssetUri(uri)
  return {
    ...item,
    filename: `${item.filename.split(".")[0]}.${ext}`,
    type: `${item.mediaType === "photo" ? "image/jpeg" : "video/mp4"}`,
    content_type: `${item.mediaType === "photo" ? "image/jpeg" : "video/mp4"}`,
    uri,
    size,
  }
}
